import { supabaseClient } from "supabase";

/**
 * Translate text while preserving line break structure.
 * Uses a marker-based approach to maintain line breaks in a single API call.
 */
export const translate = async (text: string, targetLang: string) => {
  // Use a unique marker that won't appear in normal text
  const LINE_BREAK_MARKER = '|||LINEBREAK|||';
  
  // Normalize line endings before marking (application data may have \r\n)
  const normalizedText = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // Replace line breaks with markers
  const markedText = normalizedText.replace(/\n/g, LINE_BREAK_MARKER);
  
  // Single API call with markers
  const { data, error } = await supabaseClient.functions.invoke("translate", {
    body: { text: markedText, targetLang },
  });
  
  if (error) {
    throw error;
  }
  
  // Get translation and normalize Windows line breaks
  const translation = ((data as any).translation as string)
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');
  
  // Restore line breaks from markers
  const result = translation.replace(/\|\|\|LINEBREAK\|\|\|/g, '\n');
  
  return result;
};
